import type { ATractorAd } from "@mobility-item-page/types";
import { KeyInfo } from "../../key-info/KeyInfo.tsx";
import { ChassisNumber } from "../ChassisNumber.tsx";
import { BodyType } from "../car/BodyType.tsx";
import { ExteriorColor } from "../car/ExteriorColor.tsx";
import { Engine } from "../Engine.tsx";
import { Fuel } from "../Fuel.tsx";
import { Make } from "../Make.tsx";
import { Mileage } from "../Mileage.tsx";
import { Model } from "../Model.tsx";
import { ModelYear } from "../ModelYear.tsx";
import { RegistrationNumber } from "../RegistrationNumber.tsx";
import { Transmission } from "../Transmission.tsx";
import { WheelDrive } from "../WheelDrive.tsx";

const ATractorSpecifications = ({ ad }: { ad: ATractorAd }) => {
  return (
    <KeyInfo>
      {/*General information*/}
      <Make make={ad.model_and_make?.parent?.value} />
      <Model model={ad.model_and_make?.value} />
      <ModelYear year={ad.year} />
      <BodyType bodyType={ad.body_type} />

      {/*Product properties*/}
      {ad.engine && <Fuel fuel={ad.engine.fuel} />}
      <Engine engine={ad.engine} />
      <Mileage distance={ad.mileage} unit={ad.mileage_unit} />
      <Transmission transmission={ad.transmission} />
      <WheelDrive wheelDrive={ad.wheel_drive} />

      {/*Appearance*/}
      <ExteriorColor exteriorColor={ad.exterior_color} />

      {/*Registration, warranty, owners, etc*/}

      <RegistrationNumber registrationNumber={ad.registration_number} />
      <ChassisNumber chassisNumber={ad.chassis_number} />
    </KeyInfo>
  );
};

export default ATractorSpecifications;
